import { Table } from "@components/Legal/legalStyles";
import React from "react";

const Free = <b>FREE</b>;

export const FeesTable: React.FCC = () => {
  return (
    <Table>
      <tr>
        <th>
          <b>Third Party</b>
        </th>
        <th>
          <b>Fee</b>
        </th>
      </tr>
      <tr>
        <th>Visa / Mastercard</th>
        <td>
          2.2% + $0.30
          <br />
          <small>+1% for non-US</small>
        </td>
      </tr>
      <tr>
        <th>Amex</th>
        <td>
          3.5%
          <br />
          <small>+1% for non-US</small>
        </td>
      </tr>
      <tr>
        <th>PayPal</th>
        <td>
          1.99% + $0.49
          <br />
          <small>+1.5% for non-US</small>
        </td>
      </tr>
      <tr>
        <th>Venmo</th>
        <td>
          1.99% + $0.49
          <br />
          <small>+1.5% for non-US</small>
        </td>
      </tr>
      <tr>
        <th>Apple Pay / Google Pay</th>
        <td>
          No additonal fees
          <br />
          <small>Standard card fees apply</small>
        </td>
      </tr>
      <tr>
        <th>Cryptocurrency</th>
        <td>1%</td>
      </tr>
      <tr>
        <th>Stocks / Mutual Funds</th>
        <td>0% - {Free}</td>
      </tr>
      <tr>
        <th>Bank</th>
        <td>0% - {Free}</td>
      </tr>
      <tr>
        <th>DAF</th>
        <td>0% - {Free}</td>
      </tr>
    </Table>
  );
};
